import { FC } from 'react';
import { useTranslation } from 'react-i18next';
// Types
import MediaTypes from 'types/MediaTypes';
import Paths from 'types/Paths';
// Models
import IQuiz from 'models/Quiz';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz, selectIsQuizStarted } from 'store/quiz/quizSelectors';
// Components
import { Button } from 'components/Buttons';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
import { sendAnalyticsTrack } from 'store/player/playerAsync';

const ButtonPlayNow:FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  // State
  const quiz:IQuiz = useAppSelector(selectQuiz);
  const isQuizStarted:boolean | undefined = useAppSelector(selectIsQuizStarted);

  const { buttonTitle } = quiz.landingPage;

  const navigateTo = useNavigateTo();

  const handleClick = () => {
    let path:Paths = 'countdown';
    let params = {};
    if ( quiz.waiver.enabled ){
      path = 'waiver';
    } else {
      if ( quiz.brandVideo ){
        path = 'media';
        params = { mediaType: MediaTypes.BrandVideo };
      }
    }
    dispatch(sendAnalyticsTrack({ event: 'quizStart', quizId: quiz._id }));
    navigateTo(path, params);
  }

  const buttonText = buttonTitle ?? t('buttons.playNow');

  if ( !isQuizStarted || !quiz.questions?.length ) return null;
  return (
    <div className="mb-6 flex justify-center">
      <Button
        className="w-11/12 !text-2xl uppercase primary-button"
        onClick={handleClick}
      >{buttonText}</Button>
    </div>
  )
}

export default ButtonPlayNow;
